import { Modal } from "antd";
import { Col, Row } from "react-bootstrap";
import { BsPerson } from "react-icons/bs";
import ProfileItem from "../../vcDetailsScreen/components/profileItem";
import { LiaUserLockSolid } from "react-icons/lia";
import { PiUsersFour } from "react-icons/pi";
import { MdOutlineMeetingRoom } from "react-icons/md";
import NoImage from "../../../assets/images/noimage.jpg";

function InvestorInfo(props: any) {
  const investors = props?.item?.investors || {};
  return (
    <Modal open={props.visible} onCancel={props.onCancel} footer={false}>
      <div className="CompanyInfo-box1 mt-3">
        <div style={{ border: "1px solid #f2f2f2", padding: 10 }}>
          <img
            src={investors?.logo || NoImage}
            style={{ width: 100, height: 80, objectFit: "contain" }}
          />
        </div>
      </div>
      <div
        className="VcDetailsScreen-text4 my-2"
        style={{ fontSize: 20, textAlign: "center" }}
      >
        {investors?.company}
      </div>
      <Row className="my-2">
        <Col xs={6}>
          <ProfileItem
            icon={<MdOutlineMeetingRoom size={20} color="#0026ab" />}
            label={"Meeting Room"}
            value={investors?.meeting_room || ""}
          />
        </Col>
        <Col xs={6}>
          <ProfileItem
            icon={<PiUsersFour size={20} color="#0026ab" />}
            label={"Attendees"}
            value={investors?.Attendees?.length + 1 || 1}
          />
        </Col>
      </Row>
      <hr />
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        <strong style={{ marginRight: 10 }}>{1}.</strong>
        <div>
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 10 }}
          >
            <BsPerson size={20} color="#0026ab" style={{ marginRight: 6 }} />
            <span className="VcDetailsScreen-text4">{investors?.fullname}</span>
          </div>{" "}
          <div style={{ display: "flex", alignItems: "center" }}>
            <LiaUserLockSolid
              size={20}
              color="#0026ab"
              style={{ marginRight: 6 }}
            />
            <span className="VcDetailsScreen-text3">{investors?.jobTitle}</span>
          </div>
        </div>
      </div>
      <hr />
      {investors?.Attendees?.length > 0 &&
        investors?.Attendees?.map((item: any, index: number) => (
          <div key={index}>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <strong style={{ marginRight: 10 }}>{index + 2}.</strong>
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <BsPerson
                    size={20}
                    color="#0026ab"
                    style={{ marginRight: 6 }}
                  />
                  <span className="VcDetailsScreen-text4">
                    {item?.fullName}
                  </span>
                </div>{" "}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <LiaUserLockSolid
                    size={20}
                    color="#0026ab"
                    style={{ marginRight: 6 }}
                  />
                  <span className="VcDetailsScreen-text3">
                    {item?.jobTitle}
                  </span>
                </div>
              </div>
            </div>
            {index !== investors?.Attendees?.length - 1 && (
              <hr style={{ margin: "15px 0" }} />
            )}
          </div>
        ))}
    </Modal>
  );
}

export default InvestorInfo;
